

export const ThemeLight = {
  name: "light",
  color: "#f1f1f1",
  text: "#000",
  dash: {
    background: "#fff",
    text: "#000"
  },
  table: {
    bg: "#fff",
    line:  {
      main: "#DDE6ED",
      even: "#fff"
    },
    border: "#e9e9e9",
    text: {
      main: "#4C4A4A",
      hover: "#F1F4F9"
    },
    bghover: "#525252"
  },
  header: {
    text: "#178BBF",
    background: "#fff",
  },
  menu: {
    main: "#178BBF",
    contrast: "#084662",
  }
}


